import React, { FC, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getRandomImage } from '../services/config';
import { cdnUrl } from '../constants/generic';
import SearchHistory from 'components/shared/SearchHistory';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import SearchDynamicFH from 'components/dynamic/Search/SearchDynamicFH';
import { MainContext } from 'contexts/MainContext';

const MainDynamicPage: FC = () => {
  const [bgImage, setBgImage] = useState<{ backgroundImage: string }>();
  const location = useLocation();
  const isEnigma = useContext(MainContext).isEnigma;

  useEffect(() => {
    if (isEnigma) return;
    (async () => {
      const response = await getRandomImage();
      setBgImage({ backgroundImage: `url(${cdnUrl + response?.imageUrl})` });
    })();
  }, [location.pathname]); // eslint-disable-line

  return (
    <div className="display-flex">
      <section className="main-page hotels" style={bgImage}>
        <div className="main-page-single position-relative">
          <SearchDynamicFH matrixConfig="Dynamic_FMHM" />
          <SearchHistory hideArrow={true} />
        </div>
      </section>
    </div>
  );
};

export default withErrorBoundary(MainDynamicPage, 'MainDynamicPage');
